import { GameShotMap } from '@/components/game/vis/GameShotMap';
import { PlayerRadarChart } from '@/components/player/radar/PlayerRadarChart';
import { PlayerEventBuckets } from '@/components/player/vis/PlayerEventBuckets';
import { PlayerEventMap } from '@/components/player/vis/PlayerEventMap';
import { PlayerHeatMap } from '@/components/player/vis/PlayerHeatMap';
import { PlayerInfo } from '@/components/player/vis/PlayerInfo';
import { PlayerPositions } from '@/components/player/vis/PlayerPositions';
import { PlayerShotMap } from '@/components/player/vis/PlayerShotMap';
import { TeamRadarChart } from '@/components/team/radar/TeamRadarChart';
import { TeamDashboardSquadTable } from '@/components/team/vis/TeamDashboardSquadTable';
import { TeamEventBuckets } from '@/components/team/vis/TeamEventBuckets';
import { TeamEventMap } from '@/components/team/vis/TeamEventMap';
import { TeamHeatMap } from '@/components/team/vis/TeamHeatMap';
import { TeamShotMap } from '@/components/team/vis/TeamShotMap';
import { PlayerMinutesPlayed } from '@/components/visualisations/MinutesPlayed/PlayerMinutesPlayed';
import { PitchVisComponents, VisComponents } from '@/types/visualisation';

/* 
  We may need to review how we build these components as there is
  some duplication using the MetricKeyFallbackWrapper component.
  As we make more visualisations across different entities
  (Player, Team, Keeper, etc) we should consider if they should
  be DRY'd out into there own components.
*/

export const playerPitchVisComponents: PitchVisComponents = {
  heatMap: PlayerHeatMap,
  eventMap: PlayerEventMap,
  passSonar: PlayerEventMap,
  shotMap: PlayerShotMap,
  eventBuckets: PlayerEventBuckets,
};

export const playerVisComponents: VisComponents = {
  ...playerPitchVisComponents,
  radar: PlayerRadarChart,
  positionMap: PlayerPositions,
  info: PlayerInfo,
  minutesPlayed: PlayerMinutesPlayed,
};

export const teamPitchVisComponents: PitchVisComponents = {
  heatMap: TeamHeatMap,
  eventMap: TeamEventMap,
  passSonar: TeamEventMap,
  shotMap: TeamShotMap,
  eventBuckets: TeamEventBuckets,
};

export const teamVisComponents: VisComponents = {
  ...teamPitchVisComponents,
  radar: TeamRadarChart,
  squad: TeamDashboardSquadTable,
};

const gamePitchVisComponents = {
  shotMap: GameShotMap,
};

export const gameVisComponents = {
  ...gamePitchVisComponents,
};
